import { render, staticRenderFns } from "./AddWarehouseToCompany.vue?vue&type=template&id=3e37909d&"
import script from "./AddWarehouseToCompany.vue?vue&type=script&lang=ts&"
export * from "./AddWarehouseToCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports